import React from 'react'
import { connect } from 'react-redux'
import { getFullUser } from '../../../selectors';
import { Field, reduxForm } from 'redux-form';
import {validate} from 'validate.js';

import { Row, Form, FormGroup, Label, Col, Input, FormFeedback, FormText } from 'reactstrap';
import { userActions } from '../../../actions';
import submit from './submit';

validate.validators.checked = function(value, options) {
    if (value !== 'true') return options.message || "Must be checked";
};

const constraints = {
    firstName: {
        presence: {
            allowEmpty: false,
            message: "Cannot be empty"
        },
    },
    lastName: {
        presence: {
            allowEmpty: false,
            message: "Cannot be empty"
        },
    },
    email: {
        presence: {
            allowEmpty: false,
            message: "Cannot be empty"
        },
        email: {
            message: "Doesn't look like a valid email"
        }
    },
    password: {
        presence: {
            allowEmpty: true,
            message: "Cannot be empty"
        },
        length: {
            minimum: 6,
            message: "Must be at least 6 characters"
        }
    },
    confirmPassword: {
        presence: {
            allowEmpty: true,
            message: "Cannot be empty"
        }
    }
};

const validateInputs = values => {
    const errors = {};
    for(let v in values){
        if (values.hasOwnProperty(v)) {
            let err = validate.single(values[v], constraints[v]);

            if(v === 'confirmPassword' || v === 'password'){
                // if(!err){
                    if(values.confirmPassword !== values.password){
                        errors.confirmPassword = 'Passwords do not match';
                    }
                // }
            }

            if(err){
                if(err.length > 0) {
                    errors[v] = err[0];
                }
            }
       }
    }
    return errors;
  }

const renderField = ({
        input,
        label,
        type,
        meta: { touched, error },
        ...custom
    }) => {
        let invalid = false;
        if(error && touched) invalid = true;
        return (
            <FormGroup>
                <Input
                    type={type || 'text'}
                    {...input}
                    {...custom}
                    valid={ touched && !error }
                    invalid={ invalid }
                />
                {label ? <Label check>{label}</Label> : ''}
                <FormFeedback>
                    {touched && error}
                </FormFeedback>
            </FormGroup>
        );
}

class EditUserForm extends React.Component {
    render(){
        const { handleSubmit } = this.props;
        return (
            <Form onSubmit={handleSubmit}>
                <h1>Edit Account</h1>
                <hr />
                <h6>Personal Info</h6>
                <Row form>
                    <Col md={6}>
                        <Field
                            name="firstName"
                            type="test"
                            component={renderField}
                        />
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name="lastName"
                                type="test"
                                component={renderField}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row form>
                    <Col>
                        <Field
                            name="email"
                            type="email"
                            component={renderField}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <hr />
                        <h6>Password (Leave blank if unchanged)</h6>
                    </Col>
                </Row>
                <Row form>
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name="password"
                                type="password"
                                component={renderField}
                                placeholder="Password"
                            />
                            <FormText>Must be at least 6 characters long.</FormText>
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name="confirmPassword"
                                type="password"
                                component={renderField}
                                placeholder="Confirm Password"
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <hr />
                        <h6>Preferences</h6>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormGroup check>
                            <Field
                                name="sendEmails"
                                label="Send Emails (Still in development)"
                                type="checkbox"
                                component={ renderField }
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </Form>
        )
    }
}

EditUserForm = reduxForm({
    form: 'editUserForm',
    validate: validateInputs,
    onSubmit: submit,
})(EditUserForm)


function mapStateToProps(state) {
    return {
        initialValues: getFullUser(state),
        user: getFullUser(state)
    }
}

export default connect(mapStateToProps, userActions)(EditUserForm);


// WEBPACK FOOTER //
// ./src/components/Account/Edit/EditUserForm.js